import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NominatimResponse } from '../../dto/nominatimResponse';

@Injectable({
  providedIn: 'root'
})
export abstract class MapService{

  constructor(public http: HttpClient, @Inject('BASE_URL') public baseUrl: string) {     
  }

  getMapPosition(Address): Observable<NominatimResponse> {
    var value = Address.toLowerCase();
    value = value.replace(/ä/g, 'ae');
    value = value.replace(/ö/g, 'oe');
    value = value.replace(/ü/g, 'ue');
    return this.http.get<NominatimResponse>(this.baseUrl + 'api/map/' + value)
  }


}
